import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";

function Footer() {
  return (
    <Box
      sx={{
        mt: 6,
        py: 3,
        px: 4,
        background: "linear-gradient(135deg, #312e81 0%, #4338ca 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
      }}
    >
      <AutoStoriesIcon sx={{ fontSize: 16, color: "rgba(255,255,255,0.6)" }} />
      <Typography
        sx={{
          color: "rgba(255,255,255,0.6)",
          fontSize: "0.8rem",
          fontWeight: 500,
          letterSpacing: "0.05em",
        }}
      >
        PicDict
      </Typography>
    </Box>
  );
}

export default Footer;
